<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>

    <v-flex>
      <core-upsert
        :config="config"
        :item="user"
        :hideSave="true">


        <template slot='headerActions'>          
          <v-btn
            color="secondary"
            @click="$router.push('/user')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </template>


        <template slot='actions' v-if="user.status != 'Removed'">          
          
          <!--v-btn
            color="secondary"
            @click="changeRoleModal = true"
            v-if="isAdmin && user._availableOnPlatforms">
            Change Role
          </v-btn-->

          &nbsp;

          <v-btn
            v-if="$can('upsert', 'user')"
            color="secondary"
            @click="$router.push('/protocol_roles/' + user.protocol_id)">
            Roles
          </v-btn>

          &nbsp;

          <v-btn
            v-if="$can('upsert', 'user')"
            color="purple"
            class="mx-1 white--text"
            :loading="loadingUpdate"
            @click="save">
            Update
          </v-btn>

          &nbsp;

          <v-btn
            v-if="$can('to_activate', 'user') && user.status == 'New'"
            color="purple"
            class="mx-1 white--text"
            @click="to_activate">
            To Activate
          </v-btn>

          <!--v-btn
            v-if="user.status == 'Active'"
            color="primary"
            @click="deactivate">
            <v-icon>mdi-account-off</v-icon>  Deactivate
          </v-btn-->

        </template>

       
      </core-upsert>

      <v-simple-table v-if="user.status != 'Removed'">

        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Platform
              </th>
              <th class="text-center" colspan="4">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="platform in platforms"
              :key="platform"
            >
              <td  width="25%"><b>{{ platform }}</b>
                <div style="float:right" v-if="!userStatus[platform]['protocol'] && loaded"> (Protocol not found for this platform) </div>

                <div style="display:inline;text-align:center;margin-left:5px" v-if="!loaded"> (Loading...)</div>
               
              </td>

              <td width="5%">
                <v-tooltip
                  v-if="$can('upsert', 'user')"
                  top>
                  <template
                    slot="activator"
                    slot-scope="{ on }">

                    <v-btn
                      v-on="on"
                      :disabled="userStatus[platform]['exists'] || !userStatus[platform]['protocol'] || !loaded"
                      color="green"
                      :loading="loading[platform]['create']"
                      @click="userAction('create', platform)">
                      <v-icon>mdi-account-plus</v-icon>
                    </v-btn>

                  </template>
                  <span>Create & Activate this user for {{platform}}</span>
                </v-tooltip>

                
                
              </td>


              <td width="20%">

                <div v-if="platform == 'REDCap' || platform == 'eCDS' || platform == 'SafetyDB'">
                  
                  <v-tooltip
                    v-if="!userStatus[platform]['user_protocol'] && $can('upsert', 'user')"
                    top>
                    <template
                      slot="activator"
                      slot-scope="{ on }">

                      <v-btn
                        v-if="!userStatus[platform]['user_protocol']"
                        v-on="on"
                        :disabled="!userStatus[platform]['exists'] || !loaded"
                        color="green"
                        :loading="loading[platform]['createProtocol']"
                        @click="userAction('createProtocol', platform)">
                        <v-icon> mdi-clipboard-text</v-icon>
                      </v-btn>

                    </template>
                    <span>Activate this user for Protocol {{user.protocol.name}}</span>
                  </v-tooltip>


                  <v-tooltip
                    v-if="userStatus[platform]['user_protocol'] && $can('upsert', 'user')"
                    top>
                    <template
                      slot="activator"
                      slot-scope="{ on }">

                      <v-btn
                      v-if="userStatus[platform]['user_protocol']"
                        v-on="on"
                        :disabled="!userStatus[platform]['exists'] || !loaded"
                        color="primary"
                        :loading="loading[platform]['removeProtocol']"
                        @click="userAction('removeProtocol', platform)">
                        <v-icon> mdi-clipboard-text-off</v-icon>
                      </v-btn>

                    </template>
                    <span>Remove this user from Protocol {{user.protocol.name}}</span>
                  </v-tooltip>

                  <div v-if="userStatus[platform]['user_protocol'] && !$can('upsert', 'user')">
                    Protocol <v-icon color="green">mdi-check</v-icon> 
                  </div>

                </div>
              </td>

              
              <td  width="25%">

                <v-tooltip
                  v-if="!userStatus[platform]['active'] && $can('upsert', 'user')"
                  top>
                  <template
                    slot="activator"
                    slot-scope="{ on }">

                    <v-btn
                      v-on="on"
                      :disabled="!userStatus[platform]['exists'] || !loaded"
                      color="green"
                      :loading="loading[platform]['activate']"
                      @click="userAction('activate', platform)">
                      <v-icon>mdi-account-check</v-icon>
                    </v-btn>

                  </template>
                  <span>Activate this user for {{platform}}</span>
                </v-tooltip>

                <div v-if="userStatus[platform]['active'] && !$can('upsert', 'user')">
                  Platform <v-icon color="green">mdi-check</v-icon> 
                </div>

                <v-tooltip
                  v-if="userStatus[platform]['active'] && $can('upsert', 'user')"
                  top>
                  <template
                    slot="activator"
                    slot-scope="{ on }">

                    <v-btn
                      v-on="on"
                      :disabled="!loaded"
                      color="primary"
                      :loading="loading[platform]['deactivate']"
                      @click="userAction('deactivate', platform)">
                      <v-icon>mdi-account-off</v-icon> 
                    </v-btn>

                  </template>
                  <span>Deactivate this user for {{platform}}</span>
                </v-tooltip>
              
              </td>


              <td width="25%">

                <div v-if="platform != 'REDCap'">

                <v-tooltip
                  v-if="$can('upsert', 'user')"
                  top>
                  <template
                    slot="activator"
                    slot-scope="{ on }">

                    <v-btn
                      v-on="on"                  
                      color="red"
                      :disabled="!userStatus[platform]['exists'] || !loaded"
                      @click="userAction('remove', platform)">
                      <v-icon>mdi-account-remove</v-icon> 
                    </v-btn>

                  </template>
                  <span>REMOVE this user for {{platform}}</span>
                </v-tooltip>

                </div>
              
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      
    </v-flex>

     <v-flex md12>
        <core-table
          ref="userLogTable"
          hide-upsert
          hide-bar
          title="User Logs"
          hide-actions
          :config="config_user_log"
          :filters="{ user_id:$route.params.id  }">
        </core-table>
      </v-flex>

      <v-dialog v-model="confirmModal" persistent max-width="500px">
        <material-card color="red" :title="confirmTitle">
          <v-form ref="form">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex md12>
                 {{confirmMessage}}
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-flex xs12 text-right>
            <v-btn class="mx-1 font-weight-light" color="danger" @click="confirm()">Confirm</v-btn>
            <v-btn
              class="mx-1 font-weight-light"
              color="primary"
              @click="closeConfirm()">Cancel</v-btn>
          </v-flex>
        </material-card>
      </v-dialog>


    <!--app-change-role-modal v-model="changeRoleModal" :item="user" :userStatus="userStatus" @changed="roleChanged"/-->

  </v-container>
</template>

<script>
import { getDetail, getList, upsert, put } from '@/api/base_entity'
import config from './config_upsert.js'
import config_user_log from './config_user_log.js'
import { activate, create, remove, createProtocol, removeProtocol, deactivate, checkStatus } from '@/api/newuser'

export default {
  inheritAttrs: false,
  data () {
    return {
      config,
      config_user_log,
      user: {protocol:{}, protocol_roles:{}},
      loading:  {
        'REDCap': {'create':false, 'createProtocol':false, 'removeProtocol':false, 'deactivate':false, 'remove':false}, 
        'SafetyDB': {'create':false, 'createProtocol':false, 'removeProtocol':false, 'deactivate':false, 'remove':false},
        'eCDS': {'create':false, 'createProtocol':false, 'removeProtocol':false, 'deactivate':false, 'remove':false},
        'EMN Logistic': {'create':false, 'createProtocol':false, 'removeProtocol':false, 'deactivate':false, 'remove':false}
      },
      userBck: {},
      itemId: null,
      isNew: true,
      userStatus: {'REDCap':{}, 'SafetyDB':{}, 'eCDS':{}, 'EMN Logistic': {}, 'protocols': {}},
      loaded: false,
      // changeRoleModal: false,
      confirmModal: false,
      confirmMessage: null,
      confirmTitle: null,
      action: null,
      platform: null,
      loadingUpdate:false
    }
  },
  async created () {
    if (this.$route.params.id !== 'new') {
      let user = await getDetail('user', this.$route.params.id)

      if(!user.id)
        return
        
      user._availableOnPlatforms = true
      this.user = user

      this.userBck = JSON.parse(JSON.stringify(user))

      const retPS = await getList('protocol_has_site', {protocol_id:this.user.protocol_id}, {rowsPerPage:-1})
      const protocol_sites_id = retPS.data.map( r => {
          return r.site_id
        })
      const retS =  await getList('site', {id:protocol_sites_id}, {rowsPerPage:-1})
      this.config.fields.filter( r => r.value == 'sites')[0].items = retS.data
      this.isNew = false
      this.checkStatus()
    }

  },
  async mounted () {
  
  },
  computed: {
    isAdmin() {
      return this.$store.getters.user.role == 'Administrator'
    },
    platforms() {
      
      let platforms = []
      if(this.user.protocol_roles.redcap_map) {
        platforms.push('REDCap');
      }
      if(this.user.protocol_roles.safety_map) {
        platforms.push('SafetyDB');
      }
      if(this.user.protocol_roles.ecds_map) {
        platforms.push('eCDS');
      }
      // if(this.user.protocol_roles.logistic_map) {
      //   platforms.push('EMN Logistic');
      // }

      return platforms
    }
  },
  methods: {
    to_activate() {

      put('user/to_activate', this.user.id, this.user).then( (data) => {

        this.user = data.data

        this.$root.$emit('openSnackbar', {
          message: 'User to Activate correctly',
          color: 'success'
        })

        // this.checkStatus()

      }).catch(e => {
        this.$root.$emit('openSnackbar', {
          message: 'An Error occurred during the User update. ' +
            e && e.response ? e.response.data.message : 'Error',
          color: 'error'
        })
      })

    },
    async save() {
     
      if(JSON.stringify(this.user.sites) != JSON.stringify(this.userBck.sites) && this.user._availableOnPlatforms && this.user.status == 'Active') {
        const ret = await this.$root.$confirm.open('Confirm update USER SITES', 'Are you sure to change the USER SITES for all enabled platforms?', { color: 'red' })
         if (!ret) {
           return
         }
         this.user._changeSites = true;
      }

      if(this.user.protocol_roles_id != this.userBck.protocol_roles_id && this.user._availableOnPlatforms && this.user.status == 'Active') {
        const ret = await this.$root.$confirm.open('Confirm USER PROFILE', 'Are you sure to change the USER PROFILE for all enabled platforms?', { color: 'red' })
         if (!ret) {
           return
         }
         this.user._changeRole = true;
      }
 
      this.loadingUpdate = true

      upsert('user', this.user).then( (data) => {

        this.user = data.data
        this.userBck = JSON.parse(JSON.stringify(this.user))

        this.$root.$emit('openSnackbar', {
          message: 'User updated correctly',
          color: 'success'
        })

        this.checkStatus()

      }).catch(e => {
        this.$root.$emit('openSnackbar', {
          message: 'An Error occurred during the User update. ' +
            e && e.response ? e.response.data.message : 'Error',
          color: 'error'
        })
      }).finally( () => {
        this.loadingUpdate = false
      })

    },
    // saved (item) {
    //   this.itemId = Number(item.assetId)
    //   this.isNew = false
    //   this.checkStatus()
    // },
    checkStatus() {
      checkStatus(this.user.id).then( ret => {
        if(ret['REDCap'].exists || ret['SafetyDB'].exists || ret['eCDS'].exists) {
          // this.user.status = 'Active'
          // upsert('user', this.user)
          this.user._availableOnPlatforms = true
        } else {
          this.user._availableOnPlatforms = false
        }

        this.user.userStatus = ret
        this.userStatus = ret
        this.loaded = true
      })
    },
    userAction(action, platform) {

      this.confirmTitle = "Confirm " + action 
      this.confirmMessage = "Are you sure you want " + action.toUpperCase() + " this user for the platform " + platform + " ?"
      this.action = action
      this.platform = platform
      this.confirmModal = true
    },
    confirmUserAction(action, platform) {
       
      this.loading[platform][action] = true
      const userActions = {create, activate, deactivate, remove, createProtocol, removeProtocol};

      userActions[action](this.user.id, platform).then( ret => {

        this.checkStatus(this.user.id)
        
        this.$refs.userLogTable.getData();

        this.$root.$emit('openSnackbar', {
          message: ret.message,
          color: 'green'
        })
        
        
      }).catch( err => {
        this.$root.$emit('openSnackbar', {
          message: err.response.data.message,
          color: 'error'
        })
      }).finally( () => {
        this.loading[platform][action] = false
      })
      
    },
    // async roleChanged() {
    //     this.user = await getDetail('user', { id: this.user.id })
    //     this.checkStatus()
    //     this.$refs.userLogTable.getData();
    // },
    confirm() {
      this.confirmUserAction(this.action, this.platform) 
      this.closeConfirm()
    },
    closeConfirm() {
      this.confirmModal = false
    }

  }
}
</script>

<style>
#core-view {
  padding-bottom: 100px;
}

.theme--light.v-label {
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
}
</style>
